export const isClient = typeof window !== 'undefined';
export const isSsr = !isClient;
